import type { NudgeSettingPayload } from 'types/NudgeSetting';

import { getRequest, patchRequest } from '../../methods';

const settingsGetNudgeSettings = () => getRequest('settings/nudge_settings');

const settingsGetNudgeSetting = (id: number) =>
  getRequest(`settings/nudge_settings/${id}`);

const settingsUpdateNudgeSetting = (id: number, payload: NudgeSettingPayload) =>
  patchRequest(`settings/nudge_settings/${id}`, payload);

const nudgeSettings = {
  settingsGetNudgeSettings,
  settingsGetNudgeSetting,
  settingsUpdateNudgeSetting,
};

export default nudgeSettings;
